<template>
  <div>
    <v-card class="grayBorder" flat color="#c4e7ff"
      ><div class="pa-2 d-flex flex-row flex-wrap justify-space-between">
        <div>
          <div class="title">Coding Widget</div>
          <!-- <div class="body-1 ml-1">Should I code 992x3 or 992x4 ?</div> -->
        </div>
        <v-btn
          small
          text
          color="primary"
          v-if="canClearFormRisk || canClearFormProblem"
          @click="doClearForm()"
          >Clear Form</v-btn
        >
      </div>
    </v-card>
    <div
      v-if="json && json.intro"
      class="mt-4 mb-2 mx-1 mx-sm-4 introText"
      v-html="json.intro"
    ></div>

    <v-fade-transition>
      <!-- <div
        class="d-flex flex-row flex-wrap align-start my-8 mx-1"
        v-if="json && json.flowchart"
      > -->
      <v-container v-if="json && json.flowchart">
        <v-row
          ><v-col cols="12" sm="3">
            <v-card
              class="grayBorder fill-height d-flex flex-column align-space-between gradBkg1"
              flat
              min-height="300"
            >
              <!--  :min-width="$vuetify.breakpoint.smAndUp ? '20%' : '100%'" -->
              <v-card-title class="py-2 px-4 d-flex flex-row"
                ><div>Risk</div>
                <v-spacer></v-spacer>
                <definition-list-dialog
                  v-if="json.flowchart_risk.definitions"
                  :definitionList="json.flowchart_risk.definitions"
                  :definitions="json.definitions"
                ></definition-list-dialog>
              </v-card-title>
              <v-divider class=""></v-divider>
              <v-card-text class="">
                <div class="">
                  <div class="font-weight-bold mb-2">
                    {{ json.flowchart_risk.question }}
                  </div>
                  <coding-widget-element
                    :options="json.flowchart_risk.options"
                    :definitions="json.definitions"
                    :clearForm="clearFormRisk"
                    :wide="'100%'"
                    @canClearForm="
                      if ($event) canClearFormRisk = true;
                      clearFormRisk = false;
                    "
                    @problem="risk = $event"
                  ></coding-widget-element>
                </div>
              </v-card-text>
              <!-- <v-spacer></v-spacer> -->
              <!-- <div v-if="risk && json.codes[risk]" class="px-4 caption">
                Risk Result: {{ json.codes[risk].name }} ({{
                  json.codes[risk].code
                }})
              </div> -->
            </v-card>
          </v-col>
          <v-col cols="12" sm="9">
            <v-card
              class="grayBorder fill-height d-flex flex-column align-space-between gradBkg1"
              flat
              min-height="300"
            >
              <!--  :min-width="$vuetify.breakpoint.smAndUp ? '70%' : '100%'" -->
              <v-card-title class="py-2 px-4">Problems</v-card-title>
              <v-divider class=""></v-divider>
              <v-card-text>
                <div class="font-weight-bold mb-2">
                  {{ json.flowchart.question }}
                </div>
                <coding-widget-element
                  :options="json.flowchart.options"
                  :definitions="json.definitions"
                  :clearForm="clearFormProblem"
                  @canClearForm="
                    if ($event) canClearFormProblem = true;
                    clearFormProblem = false;
                  "
                  @problem="problem = $event"
                  @activeDefinitions="problemDefinitions = $event"
                ></coding-widget-element>
              </v-card-text>
              <!-- <v-spacer></v-spacer>
              <div v-if="problem && json.codes[problem]" class="px-4 caption">
                Problem Result: {{ json.codes[problem].name }} ({{
                  json.codes[problem].code
                }})
              </div> -->
            </v-card>
          </v-col></v-row
        >

        <v-row>
          <v-col cols="12">
            <v-card class="pa-2 grayBorder gradBkg2" flat :loading="loading">
              <!-- {{ loading }} -->

              <v-card-title class="py-0 px-4"
                >Result

                <span
                  v-if="!loading && result"
                  class="text-h6 ml-4 blue--text darken-2"
                  >{{ result.name }} ({{ result.code }})</span
                >
              </v-card-title>

              <!-- <v-divider class="mb-2"></v-divider> -->
              <div class="ma-2">
                <div>
                  <v-fade-transition>
                    <v-progress-circular
                      v-if="loading"
                      size="18"
                      indeterminate
                      color="primary"
                      class="mx-3"
                    ></v-progress-circular>
                  </v-fade-transition>
                </div>

                <v-fade-transition>
                  <div v-if="!loading && result">
                    <!-- Billable Code: -->

                    <div class="d-flex flex-column flex-sm-row my-2">
                      <v-card
                        flat
                        class="align-stretch ma-1 pa-2 resultTD order-2 order-sm-1"
                        ><div
                          class="font-weight-medium mx-4 d-flex align-center justify-center"
                          :class="{ resultHeaderSize: !isMobile }"
                        >
                          RISK of Complications and/or Morbidity/Mortality of
                          Patient Management
                        </div>
                        <v-divider></v-divider>
                        <v-card-text class="darkerCardText">
                          <div class="blueResultText">
                            {{ json.codes[risk].name }} ({{
                              json.codes[risk].code
                            }})
                          </div>
                          <!-- <b>{{ risk }} Risk</b> -->
                          <!-- {{ json.definitions }}  -->
                          <!-- {{ riskDefinition }} -->
                          <div v-if="json.definitions" class="mx-auto">
                            <div v-for="key in riskOptions" :key="key">
                              <vue-markdown
                                class=""
                                v-if="
                                  json.definitions[key] &&
                                  key == risk.toLowerCase()
                                "
                              >
                                {{
                                  json.definitions[key].definition
                                }}</vue-markdown
                              >
                            </div>
                            <!-- <vue-markdown class="ml-2" >
                              {{ json.definitions[key].definition }}</vue-markdown
                            ></div> -->
                          </div>
                        </v-card-text></v-card
                      >

                      <v-card
                        flat
                        class="align-stretch ma-1 pa-2 resultTD order-3 order-sm-2"
                        ><div
                          class="font-weight-medium mx-4 d-flex align-center justify-center"
                          :class="{ resultHeaderSize: !isMobile }"
                        >
                          Number/Complexity of PROBLEMS
                        </div>
                        <v-divider></v-divider>
                        <v-card-text class="darkerCardText">
                          <div class="blueResultText">
                            {{ json.codes[problem].name }} ({{
                              json.codes[problem].code
                            }})
                          </div>
                          <div class="">
                            <div
                              v-for="def in reversedProblemDefinitions"
                              :key="def"
                              class="mb-1"
                            >
                              <b> {{ json.definitions[def].name }}</b>

                              <vue-markdown class="">
                                {{
                                  json.definitions[def].definition
                                }}</vue-markdown
                              >
                            </div>
                          </div></v-card-text
                        ></v-card
                      >

                      <v-card
                        flat
                        class="align-stretch ma-1 pa-2 resultTD order-1 order-sm-3"
                      >
                        <div
                          class="font-weight-medium mx-4 d-flex align-center justify-center"
                          :class="{ resultHeaderSize: !isMobile }"
                        >
                          Level of MDM
                          <!-- <div class="blue--text">{{ result.name }}</div> -->
                        </div>
                        <v-divider></v-divider>
                        <v-card-text class="darkerCardText">
                          <div class="blueResultText">
                            {{ result.name }} ({{ result.code }})
                          </div>
                          <!-- <b>{{ risk }}</b> -->
                          <div v-for="(time, code) in result.time" :key="code">
                            <div>
                              <b>{{ code }}:</b> {{ time }}
                            </div>
                          </div></v-card-text
                        ></v-card
                      >

                      <!-- <v-card flat class="align-stretch ma-2 pa-2 resultTD"
                      ><div class="font-weight-bold"></div
                    ></v-card> -->
                    </div>
                  </div>
                  <div v-else-if="!loading">
                    (Please enter a RISK and complete the PROBLEM flowchart
                    above)
                  </div>
                </v-fade-transition>
              </div>
            </v-card>
          </v-col></v-row
        >
      </v-container>

      <loading v-else message="Loading algorithms . . . "></loading>

      <!-- </div> -->
    </v-fade-transition>
    <!-- {{ json.definitions }} -->
  </div>
</template>

<script>
import GetJsonMixin from "@/assets/js/GetJsonMixin";
import CodingWidgetElement from "@/components/icdStuff/CodingWidgetElement.vue";
import Loading from "@/components/universalStuff/Loading.vue";
import VueMarkdown from "@adapttive/vue-markdown";

export default {
  name: "CodingWidget",
  props: {},
  components: {
    CodingWidgetElement,
    Loading,
    DefinitionListDialog: () =>
      import("@/components/universalStuff/DefinitionListDialog.vue"),
    VueMarkdown,
  },
  mixins: [GetJsonMixin],
  data: function () {
    return {
      json: null,
      clearFormRisk: false,
      clearFormProblem: false,
      canClearFormRisk: false,
      canClearFormProblem: false,
      risk: null,
      problem: null,
      loading: false,
      riskDefinition: null,
      problemDefinitions: [],
      riskOptions: ["straightforward", "low", "moderate", "high"],
    };
  },
  methods: {
    doClearForm() {
      this.clearFormRisk = true;
      this.clearFormProblem = true;
    },
    briefLoading(time = 300) {
      const that = this;
      this.$nextTick(() => {
        that.loading = true;
      });
      setTimeout(function () {
        that.loading = false;
      }, time);
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    result: function () {
      if (!this.problem || !this.risk) return null;
      let problemObj = this.json.codes[this.problem];
      let riskObj = this.json.codes[this.risk];
      let answer = problemObj.val < riskObj.val ? problemObj : riskObj;
      return answer;
    },
    reversedProblemDefinitions() {
      return [...this.problemDefinitions].reverse();
    },
    // riskDefinition: function () {
    //   if (!this.risk) return null;
    //   return this.json.definitions[this.risk.toLowerCase()];
    // },
  },
  watch: {
    problem() {
      this.briefLoading();
    },
    risk: {
      handler: function (val) {
        this.riskDefinition =
          this.json.definitions[val.toLowerCase()]?.definition;
      },
      deep: true,
    },
  },
  mounted() {
    this.getJSON("em_flowchart"); // from the mixin
    // just to un-highlight any billing codes menu item
    this.$store.dispatch("setModeAndDetail", {
      mode: null,
      detail: null,
    });
  },
  metaInfo() {
    return {
      title: "EyeDock/Billing | Coding Widget",
    };
  },
};
</script>

<style scoped>
.introText {
  font-size: 0.8em;
}
.gradBkg1 {
  background-image: linear-gradient(180deg, #dbf0ff, #f8fbfc) !important;
}
.gradBkg2 {
  background-image: linear-gradient(180deg, #ffebd7, #fefaf7) !important;
}
.resultTD {
  background-color: #ffffff98 !important;
  min-width: 230px;
  max-width: 650px;
  border: 1px solid #0000001f;
}
/* .min35 {
  min-width: 35%;
} */
.blueResultText {
  color: #1976d2 !important;
  white-space: nowrap;
  font-size: 0.875rem !important;
  font-weight: 600;
  letter-spacing: 0.0071428571em !important;
  line-height: 1.375rem;
  font-family: "Roboto", sans-serif !important;
  margin-bottom: 12px;
}
.resultHeaderSize {
  min-height: 50px;
}

/*
	.formCaption {
  width: 100%;
  text-align: center;
  padding: 0 15px 5px 5px;
}
*/
</style>
